import { render, staticRenderFns } from "./JsonTemplatesDropdown.vue?vue&type=template&id=74215da4&scoped=true"
import script from "./JsonTemplatesDropdown.vue?vue&type=script&lang=js"
export * from "./JsonTemplatesDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74215da4",
  null
  
)

export default component.exports